import { api } from '@/api';
import { CASES_BASIC_TAG, CASES_FILTERS_TAG, CASES_TAG } from '@/api/constants';

/**
 * Response from `admin-utils/purge-org-expired-cases` — the ids of the cases
 * that were deleted. Permanently deletes every case past its retention period
 * for the organisation the global admin has currently switched into, so the
 * caller must confirm before firing this. The endpoint takes an empty body and
 * derives the case set itself (the same set `list-org-expired-cases` returns).
 */
export interface PurgeOrgExpiredCasesResponse {
  purgedCaseIds: string[];
}

const purgeOrgExpiredCasesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    purgeOrgExpiredCases: builder.mutation<PurgeOrgExpiredCasesResponse, void>({
      query: () => ({
        url: `admin-utils/purge-org-expired-cases`,
        method: 'POST',
        body: {},
      }),
      // Cases have been deleted server-side — drop every cached cases list.
      invalidatesTags: () => [{ type: CASES_TAG }, { type: CASES_BASIC_TAG }, { type: CASES_FILTERS_TAG }],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { usePurgeOrgExpiredCasesMutation } = purgeOrgExpiredCasesApi;
